import { Chats } from 'phosphor-react';
import React from 'react';

import { Container } from './styles';

interface ICardProps {
  title: string;
  description: string;
  image: string;
  link: string;
  topicsCount: number;
}

const CardCommunityCategory: React.FC<ICardProps> = ({ title, description, image, link, topicsCount }) => {
  return (
    <Container to={link}>
      <aside>
        <img src={image} alt={title} />
      </aside>
      <main>
        <h3 className="title">{title}</h3>
        <p><Chats size={16} weight="duotone" /> {topicsCount} {topicsCount === 1 ? 'tópico encontrado' : 'tópicos econtrados'} </p>
      </main>
    </Container>
  );
}

export default CardCommunityCategory;